import { render, staticRenderFns } from "./MainSystemList.vue?vue&type=template&id=7890a02e&"
import script from "./MainSystemList.vue?vue&type=script&lang=js&"
export * from "./MainSystemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports